import { menuRoutes } from "../router/menu";
import { permissionsGroup } from "../components/priviledge/PriviledgeProvider";

type UserCanFn = (action: string, group: permissionsGroup, superAdmin?: boolean) => boolean;

type DashboardAccessOptions = {
    isFacilitator?: boolean;
    isFacilitatorManager?: boolean;
};

const hasBasicDashboardAccess = (userCan: UserCanFn): boolean => (
    userCan('get_dashboard_information', 'dashboard')
    || userCan('gest_dashboard_information', 'dashboard')
);

export const canAccessFacilitatorDashboard = (userCan: UserCanFn, options?: DashboardAccessOptions): boolean => (
    Boolean(options?.isFacilitator)
);

export const canAccessFacilitatorManagerDashboard = (userCan: UserCanFn, options?: DashboardAccessOptions): boolean => (
    Boolean(options?.isFacilitatorManager)
);

export const canAccessGeneralDashboard = (userCan: UserCanFn): boolean => (
    hasBasicDashboardAccess(userCan)
    || userCan('show_complete_dashboard', 'dashboard')
);

export const canAccessDashboard = (userCan: UserCanFn, options?: DashboardAccessOptions): boolean => (
    canAccessGeneralDashboard(userCan)
    || canAccessFacilitatorManagerDashboard(userCan, options)
    || canAccessFacilitatorDashboard(userCan, options)
);

export const getAuthenticatedHomePath = (userCan: UserCanFn, options?: DashboardAccessOptions): string => (
    canAccessDashboard(userCan, options) ? menuRoutes.dashboard.path : '/users'
);
